import cogoToast from 'cogo-toast';
import { useTranslation } from 'react-i18next';
import { useMutation, UseMutationResult } from 'react-query';
import { request } from '../../../../common/src/legacy/services/httpSessionService';
import { isOtherErrorResponse } from '../../../../../types/API';
import { CompanyRegistration } from '../../../../parties/src/types';

interface Response {
  id: string;
}

export const createPartyFromCompanyRegistration = async (
  companyRegistration: CompanyRegistration,
): Promise<[Response, number]> => {
  const path = `v1/api/parties-by-company-registration`;
  const [resp, status] = await request({
    path,
    method: 'POST',
    payload: companyRegistration,
  });
  return [resp, status];
};

export const useCreatePartyFromCompanyRegistration = (): UseMutationResult<
  Response,
  unknown,
  CompanyRegistration,
  unknown
> => {
  const { t } = useTranslation();

  return useMutation<Response, unknown, CompanyRegistration, unknown>(
    async (payload) => {
      const [resp, status] = await createPartyFromCompanyRegistration({
        nr: payload.nr,
        type: payload.type,
      });

      if (isOtherErrorResponse(resp) || status >= 400) {
        return Promise.reject(resp);
      }

      return resp;
    },
    {
      onError: () => {
        cogoToast.error(t('Something went wrong'), {
          hideAfter: 5,
        });
      },
    },
  );
};
